import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
	  advice:'19277192929',		//咨询
	  rescue:'15871099160',		//救援
	  complaint:'13733572335',			//投诉
	  helpline:'19277192929',			//热线
	  max:'20000',
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
